export default "__VITE_ASSET__DBBGFiIM__"